import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { LeftFilterProps, SearchFilter } from 'types/Filters';
import queryTags from 'api/HomePage/listDatasets';
interface NodeProps {
    tags: string[];
    region: string;
}

export default function useFilters(term: string) {
    const client = useClient() as unknown as {
        query: (query: any) => Promise<any>;
    };
    const { openAlert } = useAlert();
    const [filter, setFilter] = useState<SearchFilter>({
        page: 1,
        pageSize: 1000,
        term,
    });

    const [tags, setTags] = useState<LeftFilterProps[]>([]);
    const [regions, setRegions] = useState<LeftFilterProps[]>([]);

    useEffect(() => {
        function groupAndCount(filters: string[]): LeftFilterProps[] {
            const countObj: { [key: string]: LeftFilterProps } = filters.reduce(
                (acc, filter) => {
                    if (filter.trim() !== '') {
                        // Check if tag is not an empty string
                        acc[filter] = {
                            label: filter,
                            count: (acc[filter]?.count || 0) + 1,
                            checked: false,
                        };
                    }
                    return acc;
                },
                {} as { [key: string]: LeftFilterProps },
            );
            const sortedArray = Object.entries(countObj)
                .sort(([, a], [, b]) => b.count - a.count)
                .map(([, value]) => value);
            return sortedArray;
        }

        const fetchData = async () => {
            try {
                const response = await client?.query(queryTags(filter));
                if (!response.errors) {
                    const tagsArray = response.data.listDatasets.nodes
                        .map((item: NodeProps) => item.tags)
                        .flat();

                    const resultTag = groupAndCount(tagsArray);
                    const regionsArray = response.data.listDatasets.nodes
                        .map((item: NodeProps) => item.region)
                        .flat();

                    const resultRegion = groupAndCount(regionsArray);
                    setRegions(resultRegion);

                    setTags(resultTag);
                } else {
                    openAlert({
                        message: `Something went wrong... Could not retrieve datasets ${response.errors[0]?.message}`,
                        severity: 'alert',
                    });
                }
            } catch (error: any) {
                openAlert({
                    message: `An error occurred while fetching datasets ${error?.message}`,
                    severity: 'alert',
                });
            }
        };

        if (client) {
            fetchData();
        }
    }, [client, filter, openAlert]);

    useEffect(() => {
        setFilter((prevFilter) => ({
            ...prevFilter,
            term,
        }));
    }, [term]);
    return { tags, regions };
}
